export type TemplateData = {
  [key: string]: string | number;
};

const stringTemplate = (params: { str: string; template?: TemplateData }) => {
  const { str, template } = params;

  if (!template) return str;

  const regex = new RegExp(
    Object.keys(template)
      .map(key => `({${key}})`)
      .join('|'),
    'g',
  );

  return str
    .replace(/\\n/g, '\n')
    .split(regex)
    .reduce((s, element) => {
      if (!element) return s;
      const match = element.match('^{(\\w+)}$');
      if (match) {
        return s.concat(`${template[match[1]]}`);
      }
      return s.concat(element);
    }, '');
};

export default stringTemplate;
